// Existing feature flags
const isMonitoringEnabled = () =>
  ["production"].includes(process.env.GATSBY_ENV) && !process.env.GATSBY_IS_MONITORING_DISABLED;

const isLivePreviewEnabled = [].includes(process.env.GATSBY_ENV); //todo: live preview needs fixing

const isMultiLanguageEnabled = () =>
  process.env.GATSBY_LOCALE === "true" || ["dev", "staging"].includes(process.env.GATSBY_ENV);

const getEnabledLocales = () => (isMultiLanguageEnabled() ? ["en-us", "en-au"] : ["en-us"]);
const isPersonalizeEnabled = ["dev", "staging"].includes(process.env.GATSBY_ENV);
const isNewChatEnabled = process.env.CHAT_VERSION === "messaging" || false;

module.exports = {
  isMonitoringEnabled,
  isLivePreviewEnabled,
  isMultiLanguageEnabled,
  getEnabledLocales,
  isPersonalizeEnabled,
  isNewChatEnabled,
};
